import { EnumBase } from 'hay-core-react';
class MidiaMomentoExibicaoEnum extends EnumBase {
    constructor() {
        super([
            'main.midia.momentoexibicao.anteslogin',
            'main.midia.momentoexibicao.aposlogin',
            'main.midia.momentoexibicao.antesaposlogin',
        ], 'main.midia.momentoexibicao.anteslogin');
    }
}

const instance = new MidiaMomentoExibicaoEnum();
export default instance;
